var map = {
	"./decidim/avatar-multiuser.png": 34064,
	"./decidim/brands/google.svg": 81551,
	"./decidim/cc-badge.png": 84506,
	"./decidim/decidim-logo.svg": 93682,
	"./decidim/default-avatar.svg": 36814,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 79890,
	"./decidim/icons.svg": 10961,
	"./decidim/pattern.png": 59262,
	"./decidim/placeholder-card-g.svg": 30675,
	"./decidim/placeholder-card-l.svg": 72920,
	"./decidim/placeholder.jpg": 54095,
	"./decidim/remixicon.symbol.svg": 3639,
	"./decidim/vendor/leaflet/layers-2x.png": 70650,
	"./decidim/vendor/leaflet/layers.png": 36945,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 41688,
	"./decidim/vendor/leaflet/marker-icon.png": 53383,
	"./decidim/vendor/leaflet/marker-shadow.png": 11972,
	"./decidim/vendor/social-share-button/douban.svg": 56934,
	"./decidim/vendor/social-share-button/email.svg": 10371,
	"./decidim/vendor/social-share-button/facebook.svg": 27829,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 40111,
	"./decidim/vendor/social-share-button/hacker_news.svg": 695,
	"./decidim/vendor/social-share-button/linkedin.svg": 30539,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 66292,
	"./decidim/vendor/social-share-button/pinterest.svg": 86053,
	"./decidim/vendor/social-share-button/reddit.svg": 68693,
	"./decidim/vendor/social-share-button/telegram.svg": 45260,
	"./decidim/vendor/social-share-button/tumblr.svg": 45555,
	"./decidim/vendor/social-share-button/twitter.svg": 6274,
	"./decidim/vendor/social-share-button/vkontakte.svg": 86460,
	"./decidim/vendor/social-share-button/wechat.svg": 63127,
	"./decidim/vendor/social-share-button/whatsapp.svg": 31767,
	"./decidim/vendor/social-share-button/x.svg": 14179,
	"./decidim/vendor/social-share-button/xing.svg": 84133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35749;